// Styles
import "../sass/main.scss";

// Images.
import "../img/probemal-logo.svg";
import "../img/header-contact.jpg";
import "../img/header-job.jpg";
import "../img/header-references.jpg";
import "../img/bg-contact.jpg";
import "../img/favicon.ico";
import "../img/favicon.png";

import "parsleyjs";
import barba from "@barba/core";
import Isotope from "isotope-layout";
import "magnific-popup";
import Swiper from "swiper/bundle";
import gsap from "gsap";
import lozad from "lozad";
import classie from "classie";

// logomotive-scroll
import LocomotiveScroll from "locomotive-scroll";

(function ($) {
  "use strict";

  function debug(report) {
    // console.log(report);
  }

  var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    },
    scroll,
    loadingScreen = document.querySelector(".loading-screen"),
    mainNavigation = document.querySelector(".header-vertical-navigation"),
    mobileOpener = jQuery(".hamburger"),
    mobileNavigation = jQuery(".mobile-header-navigation"),
    vpwidth;

  const observer = lozad();

  barba.hooks.before(() => {
    document.querySelector("html").classList.add("is-transitioning");
  });
  barba.hooks.after(() => {
    document.querySelector("html").classList.remove("is-transitioning");
  });

  barba.init({
    sync: true,
    transitions: [
      {
        name: "custom-transition",
        async once({ next }) {
          debug("Barba Once");
          set_current_menu_item(next);
          await contentAnimation(next.container);

          ModalStickyInit();
          //smooth(next.container);
        },
        async leave(data) {
          debug("Barba leave", data.current.container);
          await pageTransitionIn(data.current.container);
          // scroll.scrollTo(0);
          data.current.container.remove();
        },
        async beforeEnter({ next }) {
          scroll.destroy();
        },
        async enter({ next }) {
          debug("Barba enter");
          set_current_menu_item(next);
          await pageTransitionOut(next.container);
        },
      },
    ],
  });

  function get_WiewportWidth() {
    debug("WPW");
    var vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    return vw;
  }

  /**
   * Page transitions
   */
  function pageTransitionIn(container) {
    var transition;

    if (get_WiewportWidth() < 1200) {
      mobileNavigation.is(":visible")
        ? (mobileNavigation.slideUp(450), mobileOpener.removeClass("is-active"))
        : null;
    }

    transition = gsap
      .timeline()
      .to(mainNavigation, {
        duration: 0.3,
        translateX: 0,
        opacity: 0.5,
        ease: "power1.inOut",
      })
      // .to(loadingScreen, {
      //   duration: 0.2,
      //   opacity: 1,
      //   width: "100%",
      //   ease: "power1.inOut",
      // })
      .to(container, {
        duration: 0.2,
        translateX: -10,
        opacity: 0,
        ease: "power1.inOut",
      });
    return transition;
  }
  function pageTransitionOut(container) {
    // Scroll to top
    //scroll.scrollTo("top", 0, 200);
    var transition;

    transition = gsap
      .timeline({ delay: 0.3 }) // More readable to put it here
      .add("start") // Use a label to sync screen and content animation
      .to(
        mainNavigation,
        {
          duration: 0.3,
          translateX: 0,
          opacity: 1,
          ease: "power1.inOut",
        },
        "start"
      )
      .call(contentAnimation, [container], "start");

    return transition;
  }

  // Function to animate the content of each page
  function contentAnimation(container) {
    observer.observe();
    //debug(container);
    convertSVG();
    InitIsotope();
    MPInit();
    Init_Swiper();
    ModalInit();
    InitFuncFormContact();

    return gsap
      .timeline()
      .to(container, {
        duration: 0.5,
        translateX: 0,
        opacity: 1,
        stagger: 0.4,
        ease: "power1.inOut",
      })
      .call(function () {
        debug("Benoui ok maintenant on init");
        smooth(container);
        // scroll.scrollTo(0);
        //headerParallax();
      });
    //.from(mainNavigation, { duration: .5, translateY: -10, opacity: 0})
  }

  /**
   * Magnific Popup
   */
  function MPInit() {
    $.extend(true, $.magnificPopup.defaults, {
      tClose: "Fermer (Esc)", // Alt text on close button
      tLoading: "Chargement...", // Text that is displayed during loading. Can contain %curr% and %total% keys
      gallery: {
        tPrev: "Précédent (Flèche de gauche)", // Alt text on left arrow
        tNext: "Suivant (Flèche de droite)", // Alt text on right arrow
        tCounter: "%curr% de %total%", // Markup for "1 of 7" counter
      },
      image: {
        tError: '<a href="%url%">The image</a> ne peut être chargée.', // Error message when image could not be loaded
      },
      ajax: {
        tError: '<a href="%url%">The content</a> ne peut être chargé.', // Error message when ajax request failed
      },
    });

    $(".zoom-gallery").magnificPopup({
      delegate: "a",
      type: "image",
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: true,
        duration: 300, // don't foget to change the duration also in CSS
        opener: function (element) {
          return element.find("img");
        },
      },
    });
  }
  /**
   * Swipe JS
   */
  function Init_Swiper() {
    debug("InitSwiper");

    var hero = new Swiper(".swiper-hero", {
      //init: false,
      effect: "fade",
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });

    var relatedProjects = new Swiper(".swiper-related-projects", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "progressbar",
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
      on: {
        init: function () {
          debug("swiper initialized");
        },
      },
    });
  }

  /**
   * Isotope
   */
  function InitIsotope() {
    var isotopeGrid = document.querySelector(".grid");

    if (typeof isotopeGrid != "undefined" && isotopeGrid != null) {
      debug("InitIsotope");

      var comboFilters = {},
        comboFilter = [],
        qsRegex;

      var iso = new Isotope(".grid", {
        itemSelector: ".grid-item", // use a separate class for itemSelector, other than .col-
        percentPosition: true,
        // layoutMode: "fitRows",
        masonry: {
          columnWidth: ".grid-sizer",
        },
      });

      var $newdiv1 = $("<div class='col'></div>");
      iso.on("arrangeComplete", function (filteredItems) {
        observer.observe();
        if (filteredItems.length == 0) {
          $(".grid")
            .find(".grid-sizer")
            .html(
              "<div class='alert alert-info'>Pas de résultat pour ce filtrage</div>"
            );
        } else {
          $(".grid").find(".grid-sizer .alert").remove();
        }
        const target = document.querySelector(".grid").closest("section");

        scroll.update();
        scroll.scrollTo(target);
      });

      $(".button-group").each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on("click", "button", function () {
          $buttonGroup.find(".is-checked").removeClass("is-checked");
          $(this).addClass("is-checked");
        });
      });

      var $quicksearch = $(".quicksearch").keyup(
        debounce(function () {
          comboFilters = {};
          comboFilter = [];
          $(".button-group").each(function (i, buttonGroup) {
            var $buttonGroup = $(buttonGroup);
            $buttonGroup.find(".is-checked").removeClass("is-checked");
            $buttonGroup.find("button:first").addClass("is-checked");
          });

          qsRegex = new RegExp($quicksearch.val(), "gi");
          iso.arrange({
            filter: function () {
              return qsRegex ? $(this).text().match(qsRegex) : true;
            },
          });
        }, 200)
      );

      $(".filters").on("click", "button", function () {
        $(".quicksearch").val("");
        var filterID = $(this).parent().parent().attr("id");
        var filterValue = $(this).attr("data-filter");

        var comboFilter = getComboFilter(filterID, filterValue);
        debug(comboFilter.join(" "));
        // use filterFn if matches value
        //filterValue = filterFns[filterValue] || filterValue;
        iso.arrange({ filter: comboFilter.join(" ") });
      });

      function getComboFilter(filterID, filterValue) {
        comboFilter = [];
        // if (comboFilters[filterID] == undefined) {

        // Création si le filtre n'existe pas
        if (!(filterID in comboFilters)) {
          comboFilters[filterID] = [];
          if (comboFilters[filterID].length == 0) {
            comboFilters[filterID] = [];
          }
          comboFilters[filterID].push(filterValue);
        } else {
          comboFilters[filterID] = [];
          comboFilters[filterID].push(filterValue);
        }

        // si on affiche tout du filtre
        if (filterValue == "*") {
          debug("tout on delete le filtre " + filterID);
          if (filterID in comboFilters) {
            debug("la clé " + filterID + " s'y trouve bien");
            delete comboFilters[filterID];
          }
        }

        // Remplir le tableau des filtres
        for (const [key, value] of Object.entries(comboFilters)) {
          debug(`${key}: ${value}`);
          comboFilter.push(value[0]);
        }

        return comboFilter;
      }

      function debounce(fn, threshold) {
        var timeout;
        threshold = threshold || 100;
        return function debounced() {
          clearTimeout(timeout);
          var args = arguments;
          var _this = this;
          function delayed() {
            fn.apply(_this, args);
          }
          timeout = setTimeout(delayed, threshold);
        };
      }
    }
  }
  /**
   * Locomotive Scroll
   */
  function smooth(container) {
    debug("smooth");
    var sscroll = container.querySelector("[data-scroll-container]");
    scroll = new LocomotiveScroll({
      el: sscroll,
      smooth: true,
      repeat: true,
    });
  }

  /**
   * Menu states
   */
  function set_current_menu_item(next) {
    var menu = document.querySelectorAll(".menu");
    var i;
    for (i = 0; i < menu.length; i++) {
      //menu[i].style.backgroundColor = "red";
      var listItem = menu[i].querySelector(".menu-item");
      var listItemActive = menu[i].querySelector(".is-active");
      var nextItem = menu[i].querySelector(`a[href^="${next.url.href}"]`);
      //debug("set_current_menu_item", next);

      // Remove all actives elements
      var activeItems = menu[i].querySelector(".item-active");
      if (activeItems !== null) {
        activeItems.classList.remove("item-active");
      }
      if (listItemActive !== null) {
        listItemActive.classList.remove("is-active");
      }

      // Add active element
      if (nextItem !== null) {
        nextItem.classList.add("item-active");

        var listItemWithChildren = nextItem.closest(".menu-item-has-children");
        if (listItemWithChildren !== null) {
          debug("listItemWithChildren", listItemWithChildren);
          listItemWithChildren.classList.add("is-active");
        }
      }
    }
  }

  /**
   * Menu Mobile
   */
  if (mobileOpener.length) {
    jQuery("body").on("tap click", ".hamburger", function (e) {
      e.preventDefault();
      mobileNavigation.is(":visible")
        ? (mobileNavigation.slideUp(450), mobileOpener.removeClass("is-active"))
        : (mobileNavigation.slideDown({
            start: function () {
              $(this).css({
                display: "flex",
              });
            },
          }),
          mobileOpener.addClass("is-active"));
    });
  }

  /**
   * Import SVGs
   */
  //convertSVG();
  function convertSVG() {
    //debug("convertSVG");
    jQuery("img.svg").each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");

      //debug(imgURL);
      jQuery.get(imgURL, function (data) {
        var $svg = jQuery(data).find("svg");

        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        $svg = $svg.removeAttr("width");
        $svg = $svg.removeAttr("height");

        $img.replaceWith($svg);
      });
    });
  }

  /**
   * Forms
   */

  function InitFuncFormContact() {
    debug("InitFuncFormContact");

    // Contact

    $("#contact-form").parsley();
    $("#contact-form").on("submit", function (e) {
      e.preventDefault();
      var t = $(this),
        o = t.find("#valid-form");
      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          $.ajax({
            url: ajaxurl,
            data: $(this).serialize(),
            type: "POST",
            success: function (e) {
              debug(e),
                $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                  scroll.update();
                }, 225),
                setTimeout(function () {
                  $(".messages").fadeIn();
                }, 300);
            },
            error: function (e) {
              debug(e);
              $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                  scroll.update();
                }, 225),
                setTimeout(function () {
                  $(".sub_error").css("opacity", "1");
                }, 300);
            },
          });
    });

    // jobs
    $("#job-form").parsley();
    $("#curiculum").on("change", function () {
      //get the file name
      var fileName = $(this).val();
      //replace the "Choose a file" label
      $(this).next(".custom-file-label").html(fileName);
    });

    $("#job-form").on("submit", function (e) {
      e.preventDefault();
      var t = $(this),
        o = document.getElementById("valid-form");

      var file_data = $("#curiculum").prop("files")[0];

      var $form = jQuery(this);
      var formdata = window.FormData ? new FormData($form[0]) : null;
      formdata.append("file", file_data);
      var data = formdata !== null ? formdata : $form.serialize();

      debug($form.serialize());

      var formData = new FormData($(this)[0]);
      formData.append("file", file_data);
      for (var pair of formData.entries()) {
        debug(pair[0] + ", " + pair[1]);
      }

      t.parsley().validate(),
        (o.disabled = !0),
        (o.innerText = "Envoi..."),
        t.parsley().isValid() &&
          $.ajax({
            url: ajaxurl,
            cache: false,
            contentType: false,
            processData: false,
            //data: $(this).serialize(),
            data: formData,
            type: "POST",
            success: function (e) {
              debug(e),
                $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-success")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".messages").fadeIn();
                }, 300);
            },
            error: function (e) {
              $(".fields").fadeOut(200),
                setTimeout(function () {
                  $(".messages")
                    .addClass("alert alert-danger")
                    .html(e.message)
                    .fadeIn();
                }, 225),
                setTimeout(function () {
                  $(".sub_error").css("opacity", "1");
                }, 300);
            },
          });
    });

    var formDataSuppoerted = function () {
      return !!("FormData" in window);
    };

    window.Parsley.addValidator("filemaxmegabytes", {
      requirementType: "string",
      validateString: function (value, requirement, parsleyInstance) {
        if (!formDataSuppoerted()) {
          return true;
        }

        var file = parsleyInstance.$element[0].files;
        var maxBytes = requirement * 1048576;

        if (file.length == 0) {
          return true;
        }

        return file.length === 1 && file[0].size <= maxBytes;
      },
      messages: {
        en: "Fichier trop volumineux. Maximum 2Mo.",
      },
    }).addValidator("filemimetypes", {
      requirementType: "string",
      validateString: function (value, requirement, parsleyInstance) {
        if (!formDataSuppoerted()) {
          return true;
        }

        var file = parsleyInstance.$element[0].files;

        if (file.length == 0) {
          return true;
        }

        var allowedMimeTypes = requirement.replace(/\s/g, "").split(",");
        return allowedMimeTypes.indexOf(file[0].type) !== -1;
      },
      messages: {
        fr: "Ce type de fichier n'est pas valide. Seulement les fichiers .pdf, .doc et .docx sont autorisés.",
      },
    });
  }

  function ModalInit() {
    var overlay = document.querySelector(".md-overlay");

    [].slice
      .call(document.querySelectorAll(".md-trigger"))
      .forEach(function (el, i) {
        var modal = document.querySelector("#" + el.getAttribute("data-modal")),
          company_id = el.getAttribute("data-company-id");

        function removeModal(hasPerspective) {
          classie.remove(modal, "md-show");

          if (hasPerspective) {
            classie.remove(document.documentElement, "md-perspective");
          }
        }

        function removeModalHandler() {
          removeModal(classie.has(el, "md-setperspective"));
        }

        el.addEventListener("click", function (ev) {
          Modal_get_company(company_id)
            .then((data) => {
              // console.log("success", data)
              classie.add(modal, "md-show");
              overlay.removeEventListener("click", removeModalHandler);
              overlay.addEventListener("click", removeModalHandler);
              modal.querySelector(".md-content").innerHTML = data.message;

              var links = modal.querySelectorAll("a"),
                close = modal.querySelector(".md-close");

              console.log(links);

              for (let i = 0; i < links.length; i++) {
                links[i].addEventListener("click", function () {
                  console.log("Close");
                  removeModalHandler();
                });
              }

              close.addEventListener("click", function (ev) {
                ev.stopPropagation();
                removeModalHandler();
              });

              if (classie.has(el, "md-setperspective")) {
                setTimeout(function () {
                  classie.add(document.documentElement, "md-perspective");
                }, 25);
              }
            })
            .catch((error) => {
              console.log("error", error);
            });

          console.log(company_id);
        });
      });
  }

  function Modal_get_company(id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          action: "get_company_details",
          company_id: id,
        },
        success: function (data) {
          resolve(data);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  function ModalStickyInit() {
    var overlay = document.querySelector(".md-overlay");
    var modal = document.querySelector("#stickynews-modal");
    console.log(getCookie("stickynews"));
    if (overlay !== null && getCookie("stickynews") == null) {
      classie.add(modal, "md-show");
      overlay.removeEventListener("click", removeModalHandler);
      overlay.addEventListener("click", removeModalHandler);

      var close = modal.querySelector(".md-close");

      close.addEventListener("click", function (ev) {
        ev.stopPropagation();
        removeModalHandler();
      });
    }

    function removeModal(hasPerspective) {
      classie.remove(modal, "md-show");

      setCookie("stickynews", "closed", 1); //set "user_email" cookie, expires in 30 days

      if (hasPerspective) {
        classie.remove(document.documentElement, "md-perspective");
      }
    }

    function removeModalHandler() {
      removeModal(classie.has(modal, "md-setperspective"));
    }

    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }
})(jQuery);

Parsley.addMessages("fr", {
  defaultMessage: "Cette valeur semble non valide.",
  type: {
    email: "Cette valeur n'est pas une adresse email valide.",
    url: "Cette valeur n'est pas une URL valide.",
    number: "Cette valeur doit être un nombre.",
    integer: "Cette valeur doit être un entier.",
    digits: "Cette valeur doit être numérique.",
    alphanum: "Cette valeur doit être alphanumérique.",
  },
  notblank: "Cette valeur ne peut pas être vide.",
  required: "Ce champ est requis.",
  pattern: "Cette valeur semble non valide.",
  min: "Cette valeur ne doit pas être inférieure Ã  %s.",
  max: "Cette valeur ne doit pas excéder %s.",
  range: "Cette valeur doit être comprise entre %s et %s.",
  minlength:
    "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
  maxlength:
    "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
  length: "Cette valeur doit contenir entre %s et %s caractères.",
  mincheck: "Vous devez sélectionner au moins %s choix.",
  maxcheck: "Vous devez sélectionner %s choix maximum.",
  check: "Vous devez sélectionner entre %s et %s choix.",
  equalto: "Cette valeur devrait être identique.",
});

Parsley.setLocale("fr");
